module.exports = {"130638100":"雄州镇","130638101":"昝岗镇","130638102":"大营镇","130638103":"龙湾镇","130638104":"朱各庄镇","130638105":"米家务镇","130638200":"北沙口乡","130638203":"双堂乡","130638204":"张岗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130638.json
// module id = 156
// module chunks = 0